import { reducer as SchedulingReducer } from "features/Scheduling";
export default {
  scheduling: SchedulingReducer,
};
